module.exports = __webpack_public_path__ + "static/media/partidas.1f205c6a.svg";